export default __webpack_public_path__ + "images/HT.7dd579f.png";